//import { useLocation } from "react-router-dom";
import { deleteRealEstate } from "../../services/Real_estate"
import Addittional from "./Additional";
import locationlogo from "../../images/location_marker.png"
import bathroom from "../../images/bathroom.png"
import room from "../../images/room.png"
import stairs from "../../images/stairs.png"
import surface from "../../images/surface.png";
import ceilingHeight from "../../images/ceiling_height.png"
import btype from "../../images/btype.png"
import renovate from "../../images/renovate.png"
import arrow from "../../images/arrow.png"
import insta from "../../images/instagram-EstatePage.png"
import {getEstateById } from "../../services/Real_estate";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getManagers } from "../../services/Real_estate";
import { recoverRealEstate } from "../../services/Real_estate";
import { district, buildingtype, buildingStatus } from "../../helpers/changingLanguage";
import "./estatePage.css"
export default function EstatePage( ) {
	const [touchStart, setTouchStart] = useState(null);
  const [el, setEl] = useState(null);
  const [isSmall] = useState(window.innerWidth <= 1050);
  const [isSmall1] = useState(window.innerWidth <= 550);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
	const [managers, setManagers] = useState([]);
	const [loading, setLoading] = useState(true);
  const { id, estateId } = useParams();

  	
  useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

	useEffect(() => {
  getManagers()
    .then((data) => {
      setManagers(data);
    })
    .catch(console.error)
    .finally(() => {
      setLoading(false);
    });
},[]);

useEffect(() => {
    getEstateById(estateId)
      .then((res) => setEl(res))
      .catch(console.error);
  }, [estateId]);

  const manager = managers.find((m) => m.manager_id === Number(id));

  console.log("kkgskdjgc skjdhgckjsdghc hjsgdc kjsgdc gsjdcg", el);
  if (!el) return <div>Loading...</div>;
  const images =
    [...(el?.urls || []), ...(el?.docurls || [])].length > 0
      ? [...(el?.urls || []), ...(el?.docurls || [])]
      : [];

	const prevImage = () => {
    setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % images.length);
  };

  const version = el?.ubdate_date ? new Date(el?.ubdate_date).getTime() : Date.now();
const shareurl = `https://my-yerevan.am/${estateId}/0?v=${version}`;

const handleClick = () => {
  navigator.clipboard.writeText(shareurl);
  setCopied(true);
};

const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (!touchStart) return;

    const touchEnd = e.changedTouches[0].clientX;
    const distance = touchStart - touchEnd;

    if (distance > 50) {
      nextImage(); // свайп влево
    }

    if (distance < -50) {
      prevImage(); // свайп вправо
    }

    setTouchStart(null);
  };

  return (
    <div>
      <div className="estatePage">
        <div className="house-gallery">
          <div onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd} className="main-image"
	    tabIndex={0}
  	    onKeyDown={(e) => {
    		if (images.length <= 1) return;

    		if (e.key === "ArrowLeft") {
    		  prevImage();
    		}

    		if (e.key === "ArrowRight") {
    		  nextImage();
    		}
  	    }}
	  >
            <img
              className="main_imagee"
              src={images[selectedIndex]}
              alt={`House ${selectedIndex + 1}`}
              onClick={() => setIsOpen(true)}
            />
	  {!isSmall1 && <button onClick={prevImage}>
              <img
                className="prev"
                src={arrow}
                alt=""
                style={{ transform: "rotate(180deg)" }}
              />
            </button>}
            {!isSmall1 &&<button onClick={nextImage}>
              <img className="next" src={arrow} alt="" />
            </button>}
          </div>
	  {el.is_sold === true && <p style = {{color:"red", fontWeight:"bold",fontSize:30,margin:1}}>ՎԱՃԱՌՎԱԾ Է</p>}
          <div className="thumbnails">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`House ${index + 1}`}
                onClick={() => setSelectedIndex(index)}
                className={index === selectedIndex ? "active" : ""}
              />
            ))}
          </div>
	  
          {!isSmall && (
            <div className="discr">
              <p style={{ fontSize: 20, fontWeight: "bold" }}>ՆԿԱՐԱԳՐՈՒԹՅՈՒՆ</p>
              <p style={{ whiteSpace: "pre-line" ,textAlign: "start" }}>{el.discription}</p>
            </div>
          )}

          {!isSmall && (
            <div className="discr">
              <p style={{ fontSize: 20, fontWeight: "bold" }}>
                ԼՌԱՑՈՒՑԻՉ ՆԿԱՐԱԳՐՈՒԹՅՈՒՆ
              </p>
              <p style={{ whiteSpace: "pre-line", textAlign: "start" }}>{el.secret_discription}</p>
            </div>
          )}
        </div>
        <div className="mainInfochosen">
          {isSmall && (
            <div className="isrsas">
              <p className="elId">ID:{estateId}</p>
              <div className="srsas">
                {el.sale_rent === "Sale" && (
                  <p className="saleOrRent">ՎԱՃԱՌՔ</p>
                )}
	
                {el.sale_rent === "Rent" && (
                  <p className="saleOrRent">ՎԱՐՁԱԿԱԼՈՒԹՅՈՒՆ</p>
                )}
		  {el.deleted && <p style={{borderRadius:12, backgroundColor:"red", color: "white", fontWeight:"bold"}}>ՋՆՋՎԱԾ</p>}
		  
                <p
                  className={
                    el.aplication_status === "active"
                      ? "aplication_status_active"
                      : "aplication_status_passive"
                  }
                >
                  {el.aplication_status === "active" && <span>ԱԿՏԻՎ</span>}
                  {el.aplication_status === "passive" && <span>ՊԱՍԻՎ</span>}
                </p>
                {el.status === "active" && <p></p>}
                {el.status === "passive" && <p></p>}
                {el.status === "archive" && <p></p>}
                <p
                  className={
                    el.status === "regular"
                      ? "status_regular"
                      : "status_exclusive"
                  }
                >
                  {el.status === "regular" && <span>ՌԵԳՈՒԼՅԱՐ</span>}
                  {el.status === "exclusive" && <span>ԷՔՍԿԼՅՈՒԶԻՎ</span>}
                  {el.status === "document_exclusive" && (
                    <span>ՊԱՅՄ. ԷՔՍ.</span>
                  )}
                </p>
              </div>
            </div>
          )}
	  {el.percent !== 0 && <span style={{fontWeight:"bold",padding:5, backgroundColor:"blue", borderRadius:50, color:"white", fontSize:20}}>{el.percent}% ՄԻՋՆՈՐԴԱՎՃԱՐ</span>}
          {!isSmall && <p className="elId">ID:{estateId}</p>}
	  
	  {!isSmall && (
            <div className="srsas">
              {el.sale_rent === "Sale" && <p className="saleOrRent">ՎԱՃԱՌՔ</p>}
              {el.sale_rent === "Rent" && (
                <p className="saleOrRent">ՎԱՐՁԱԿԱԼՈՒԹՅՈՒՆ</p>
              )}
		  {el.deleted && <p style={{borderRadius:12,backgroundColor:"red", color: "white", fontWeight:"bold"}}>ՋՆՋՎԱԾ</p>}
              <p
                className={
                  el.aplication_status === "active"
                    ? "aplication_status_active"
                    : "aplication_status_passive"
                }
              >
                {el.aplication_status === "active" && <span>ԱԿՏԻՎ</span>}
                {el.aplication_status === "passive" && <span>ՊԱՍԻՎ</span>}
		{el.aplication_status === "archive" && <span>ԱՌԽԻՎ</span>}
              </p>
              <p
                className={
                  el.status === "regular"
                    ? "status_regular"
                    : "status_exclusive"
                }
              >
                {el.status === "regular" && <span>ՌԵԳՈՒԼՅԱՐ</span>}
                {el.status === "exclusive" && <span>ԷՔՍԿԼՅՈՒԶԻՎ</span>}
                {el.status === "document_exclusive" && (
                  <span>ՊԱՅՄԱՆԱԳՐՈՎ ԷՔՍԿԼՅՈՒԶԻՎ</span>
                )}
              </p>
            </div>
          )}
          <p className="estate_name">{el.estate_name}</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img style={{ height: 20, width: 20 }} src={locationlogo} alt="" />
            <span>
              ԵՐևԱՆ, {district(el.district)}, {el.street.toUpperCase()},{" "}
              {(el.estate_type === "apartment" ||
                el.estate_type === "commercial") && <span>շ․</span>}
              {el.building_number} {el.room_number && <span>բն․</span>}{" "}
              {el.room_number}
            </span>
          </div>
          <div style={{ display: "flex", gap: 15, alignItems: "center" }}>
            <span style={{ color: "blue", fontWeight: "bold", fontSize: 24 }}>
	  {el.price === -1 ? "ԳԻՆԸ ՊԱՅՄԱՆԱԳՐԱՅԻՆ" : `${el.price}$`}
            </span>
            {el.price !== -1 && <span>{Math.round(Number(el.price) / Number(el.surface))}$/մ²</span>}
          </div>
          <div className="deepinfo">
            <div>
              <div>
                <img className="logohelpers" src={surface} alt="" />
                <p>
                  {el.surface}մ² {isSmall1 ? "" : "մակերես"}
                </p>
              </div>
              {el.estate_type !== "land" && (
                <div>
                  <img className="logohelpers" src={room} alt="" />
                  <p>{el.rooms} սենյակ</p>
                </div>
              )}
              {el.estate_type !== "land" && (
                <div>
                  <img className="logohelpers" src={ceilingHeight} alt="" />
                  <p>{el.ceilingheight}մ</p>
                </div>
              )}
            </div>
            {el.estate_type !== "land" && (
              <div>
                <div>
                  <img className="logohelpers" src={bathroom} alt="" />
                  <p>
                    {el.bathroom} {isSmall1 ? "սանհ." : "սանհանգույց"}
                  </p>
                </div>
                <div>
                  <img className="logohelpers" src={stairs} alt="" />
                  <p>
                    {el.a_floor || el.c_floor}
                    {(el.a_floor || el.c_floor) && <span>/</span>}
                    {el.building_floor} հարկ
                  </p>
                </div>

                <div>
                  <img className="logohelpers" src={btype} alt="" />
                  <p>{buildingtype(el.buildingtype)}</p>
                </div>
              </div>
            )}
            {el.land_surface && (
              <p style={{ alignSelf: "flex-start" }}>
                ՀՈՂԱՏԱՐԱԾՔԻ ՄԱԿԵՐԵՍ{"  "}
                {el.land_surface}(Մ²)
              </p>
            )}
          </div>
          {el.estate_type !== "land" && (
            <div className="bstatus">
              <div className="renovated">
                <img className="logohelpers" src={renovate} alt="" />
                <p>{buildingStatus(el.building_status)}</p>
              </div>
 
            </div>
          )}
	  <div className="insta_new">
	  {el.new_status === "on" && <p style={{ color:"#143356", marginRight: 60 }}>ՆՈՐԱԿԱՌՈՒՅՑ</p>}
	  {el.instagram_link && <a href={el.instagram_link} target="_blank" rel="noopener noreferrer">
  		<img className="insta" src={insta} alt="Instagram" />
		</a>}
	  {el.rent_end_date && 
	     <div style={{display:"flex", flexDirection:"column"}}>
		<span>Ավարտի ժամկետ</span>
		<span>{el.rent_end_date}</span>
	     </div>}
	  </div>
          <div className="cu">
            <div>
              <p>ՄՈՒՏՔԱԳՐՄԱՆ ԱՄՍԱԹԻՎ</p>
              <p>
                {new Date(el.create_date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </p>
            </div>
            <div>
              <p>ՎԵՐՋԻՆ ՓՈՓՈԽՄԱՆ ԱՄՍԱԹԻՎ</p>
              <p>
                {new Date(el.ubdate_date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </p>
            </div>
          </div>
          <div className="mb">
            <div>
              <p style={{ fontWeight: "bold" }}>ԳՈՐԾԱԿԱԼ</p>
              <p>
                {el.broker_name} {el.broker_surname}
              </p>
              
            </div>
            <div>
              <p style={{ fontWeight: "bold" }}>ՄԵՆԵՋԵՐ</p>
              <p>
                {el.manager_name} {el.manager_surname}
              </p>
              
            </div>
          </div>
          {(manager ||
            Number(id) === Number(el.broker_id)) && (
            <div className="ownerr">
              <p>ԳՈՒՅՔԻ ՏԵՐ</p>
              <p>{el.owner_name}</p>
              <div>
                {el.owner_number.map((elem) => {
                  return <p>{elem}</p>;
                })}
              </div>
            </div>
          )}
          
            <div className="ed">
              {(manager || Number(id) === Number(el.broker_id)) && el.deleted !== true &&<button
                
		onClick={() => {
      if (window.confirm("Իսկապե՞ս ցանկանում եք ջնջել")) {
        deleteRealEstate(estateId);
        window.close();
      }
    }}      
                className="del"
              >
                ՋՆՋԵԼ
              </button>}
	      {(manager || Number(id) === Number(el.broker_id)) && el.deleted === true && (<button
            style={{ cursor: "pointer" }}
   	    onClick={() => {
      if (window.confirm("Իսկապե՞ս ցանկանում եք վերականգնել")) {
        recoverRealEstate(estateId);
              window.close();
        
      }
    }}
	    className="del"
          >
            ՎԵՐԱԿԱՆԳՆԵԼ
          </button>)}
              {(manager || Number(id) === Number(el.broker_id)) &&<button
                className="edit"
                onClick={() => {
                  window.open(`/${id}/${estateId}/add`, "_blank");
                  //navigate(`/${id}/add`, { state: { data: el } });
                }}
              >
                ՓՈՓՈԽԵԼ
              </button>}
              <button
                onClick={handleClick}
                style={{
                  backgroundColor: copied ? "gray" : "green",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                ՊԱՏՃԵՆԵԼ
              </button>
            </div>
          
          {isSmall && (
            <div className="discr">
              <p style={{ fontSize: 20,whiteSpace: "pre-line", fontWeight: "bold" }}>ՆԿԱՐԱԳՐՈՒԹՅՈՒՆ</p>
              <p style={{ textAlign: "start", whiteSpace: "pre-line" }}>{el.discription}</p>
            </div>
          )}
          {isSmall && (
            <div className="discr">
              <p style={{ fontSize: 20, fontWeight: "bold" }}>
                ԼՌԱՑՈՒՑԻՉ ՆԿԱՐԱԳՐՈՒԹՅՈՒՆ
              </p>
              <p style={{ textAlign: "start" }}>{el.secret_discription}</p>
            </div>
          )}
        </div>
      </div>
      <Addittional el={el} />
      {isOpen && (
        <div className="fullscreen" onClick={() => setIsOpen(false)}>
          <div
            className="fullscreen-content"
	        onTouchStart={handleTouchStart}
  		onTouchEnd={handleTouchEnd}
                onClick={(e) => e.stopPropagation()}
  		tabIndex={0}
  		autoFocus
  		onKeyDown={(e) => {
    		if (images.length <= 1) return;

    		if (e.key === "ArrowLeft") {
      		  prevImage();
    		}

    		if (e.key === "ArrowRight") {
    		  nextImage();
    		}
  		}}
          >
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              ✕
            </button>
            <img
              className="fullscreen-image"
              src={images[selectedIndex]}
              alt=""
            />

            {!isSmall1 &&<button onClick={prevImage} className="full-prev">
              ‹
            </button>}

	      {!isSmall1 && <button onClick={nextImage} className="full-next">
              ›
            </button>}

            <div className="fullscreen-thumbs">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setSelectedIndex(index)}
                  className={index === selectedIndex ? "active" : ""}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
